<template>
  <div class="navbar-container d-flex content align-items-center">
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <notification-dropdown class="nav align-items-end ml-auto" />

    <div class="vertical-divider"></div>

    <b-navbar-nav class="nav align-items-center">
      
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name  mb-0">
              {{ getLoggedInUser ? getLoggedInUser.username : "" }} &nbsp;&nbsp;<feather-icon size="16" icon="ChevronDownIcon" class="mr-50" />
            </p>
            
          </div>
          <b-avatar
            size="35"
            variant="light-primary"
            badge
            :src="getLoggedInUser ? getLoggedInUser.profile_image : ''"
            class="badge-minimal"
            badge-variant="primary"
          />
        </template>

        <b-dropdown-item :to="{ name: 'Profile' }"  button-class="w-100">
          <feather-icon size="16" icon="UserIcon" class="mr-50" />
          <span>Profile</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item-button @click="newPassword" button-class="w-100">
          <feather-icon size="16" icon="LockIcon" class="mr-50" />
          <span>Change Password</span>
        </b-dropdown-item-button>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <div class="vertical-divider"></div >
    <b-link class="mr-3" style="color: grey;" @click="logoutButtonClick">      
      <feather-icon size="16" icon="PowerIcon" class="mr-50" />
      <span>Logout</span>
    </b-link>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import NotificationDropdown from "./NotificationDropdown.vue";


export default {
  components: {
    NotificationDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    ...mapActions({ logout: "appData/logout" }),
    async logoutButtonClick() {
      try {
        const res = await this.logout();
        if (res.status === 204) {
          this.$router.push({ name: "Login" });
        }
      } catch (error) {
        console.log(error);
      }
    },

    async newPassword() {      
      this.$router.push({ name: "ChangePassword" });       
    },
  },
  computed: {
    ...mapGetters({
      hasRole: "appData/hasRole",
      getLoggedInUser: "appData/getLoggedInUser",
    }),
  },
};
</script>
<style scoped>
.vertical-divider {
  border-left: 1px solid #e2e0e0; 
  height: 25px;
  margin-left: 30px;
  margin-right: 30px;
}
</style>
